import axios from "axios";

export const HTTP = axios.create({
  // baseURL: 'http://localhost:8800/api/',
  baseURL: "https://congresso.easyevent.com.br/api/"
});



// WEBPACK FOOTER //
// ./src/axios/index.js